<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

// 定义常量
let data = [
  {
    name: "带动类型一",
    value: 10,
  },
  {
    name: "带动类型二",
    value: 20,
  },
  {
    name: "带动类型三",
    value: 10,
  },
  {
    name: "带动类型四",
    value: 20,
  },
  {
    name: "带动类型五",
    value: 20,
  },
];

const colorLine = [
  "#00D9EA",
  "#E0C752",
  "#6652E1",
  "#00D1C8",
  "#0495B1",
  "#7D5AFB",
  "#009D33",
];
const colorLegend = [
  "#00B4E2",
  "#D4B538",
  "#3E45DF",
  "#92EAFB",
  "#79F8B6",
  "#7D5AFB",
  "#009D33",
];

// 创建ECharts配置对象
const option = {
  title: {
    show: true,
    text: '100%',
    itemGap: 10, //主副标题之间的距离
    x: 'center', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
    y: '43%',
    subtext: '带动类型',
    textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
      fontSize: 30,
      color: '#fff'
    },
    subtextStyle: {//副标题文本样式{"color": "#aaa"}
      fontSize: 26,
      color: '#17A6FA'
    },
  },
  series: [
    // 最内刻度线
    {
      type: "gauge",
      radius: "40%",
      center: ["50%", "50%"],
      clockwise: true,
      startAngle: "90",
      endAngle: "-269.9999",
      splitNumber: 90, //线的条数
      pointer: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      tooltip: {
        show: false,
      },
      splitLine: {
        show: true,
        length: 10,
        lineStyle: {
          color: "rgba(52, 185, 232, .5)",
          width: 1,
        },
      },
      axisLabel: {
        show: false,
      },
    },
    // 外圈背景
    {
      type: "pie",
      center: ["50%", "50%"],
      radius: ["40%", "76%"],
      hoverAnimation: false,
      clockWise: false,
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: "rgba(193, 229, 255, .1)",
          color: new echarts.graphic.LinearGradient(1, 1, 1, 0, [
            {
              offset: 1,
              color: "rgba(6, 57, 56, .8)",
            },
            {
              offset: 0,
              color: "rgba(6, 57, 56, .8)",
            },
          ]),
        },
      },
      tooltip: {
        show: false,
      },
      label: {
        show: false,
      },
      data: [100],
    },
    // 数据
    {
      type: "pie",
      radius: ["50%", "65%"],
      center: ["50%", "50%"],
      label: {
        normal: {
          //   formatter: '{b}\n{d}%\t{c}',
          formatter: "{b|{b}}\n{d|{d}%}",
          rich: {
            icon: {
              fontSize: 26,
            },
            d: {
              fontSize: 26,
              padding: [5, 0, 0, 0],
              color: "#fff",
            },
            b: {
              fontSize: 30,
              padding: [0, 0, 5, 0],
              color: "#fff",
            },
          },
        },
      },
      labelLine: {
        length: 70,//视觉引导线第一段的长度
        length2: 50,//视觉引导线第二段的长度
      },
      itemStyle: {
        normal: {
          // 设置渐变
          color: function (params) {
            return {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: colorLine[params.dataIndex % colorLine.length],
                },
                {
                  offset: 1,
                  color: colorLegend[params.dataIndex % colorLegend.length],
                  // 100% 处的颜色
                },
              ],
              globalCoord: false, // 缺省为 false
            };
          },
        },
      },
      data: data,
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
